import { watch } from 'vue';
import { serializeAcademicCalendarState } from '@/js/core/utils/calendar-url-state';

export function useAcademicCalendarUrlState({ selectedYear, selectedMonths, selectedFilters }) {
  const hadInitialParams = window.location.search.length > 1;

  watch(
    [selectedYear, selectedMonths, selectedFilters],
    () => {
      const qs = serializeAcademicCalendarState({
        academicYear: selectedYear.value,
        months: selectedMonths.value,
        filters: selectedFilters.value,
      });

      window.history.replaceState(window.history.state, '', `${window.location.pathname}?${qs}`);
    },
    { deep: true, immediate: hadInitialParams }
  );
}
